import {baseSelector, useSliceDispatch} from "../../utils";
import {SearchActions} from "./actions";
import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {useSelector} from "react-redux";
import {SearchSliceState} from "./reducers";

// type SearchDispatch = SearchActions;
export const useSearchDispatch = () => useSliceDispatch<SearchActions>();

export const selectSearchSlice = createSelector(
    [
        (state: RootState) => state.search,
        (state: RootState, keys: (keyof SearchSliceState)[]) => keys
    ],
    (slice, keys) => baseSelector(slice, keys)() // Call the baseSelector function here to get the selected props
);

export const useSearchSelector = (keys: (keyof SearchSliceState)[]) => {
    return useSelector((state: RootState) => selectSearchSlice(state, keys));
}


